import { createContext } from "react";

const AttendanceContext = createContext();


export default AttendanceContext;